import { Button } from '@domain-group/suit-theme'

import { confirmAction } from '@functions/entity'

import useCampaignQuote from '@hooks/useCampaignQuote'

import type { ModalCallbacks } from '@modals/SelectEmailRecipientModal'

import type { CampaignQuoteModel } from '@models/types'

import { UseSelectEmailRecipientModalPayload } from '../../hooks/useEmailRecipient'

interface ShareQuoteButtonProps {
  callbacks: ModalCallbacks,
  campaignQuote: CampaignQuoteModel,
  hookPayload: UseSelectEmailRecipientModalPayload,
}

const ShareQuoteButton = (props: ShareQuoteButtonProps) => {
  const {
    callbacks, campaignQuote, hookPayload,
  } = props
  const { closeModal } = callbacks

  const {
    hasSelectedUsers,
    message,
    selectedRecipients,
  } = hookPayload

  const {
    callbacks: {
      sendQuote: sendQuoteFn,
    },
    creating,
  } = useCampaignQuote(campaignQuote)

  const emails = selectedRecipients.map(recipient => recipient.email)

  const sendQuotePayload = {
    callbacks: {
      action: sendQuoteFn,
      afterAction: closeModal,
    },
    options: {
      entityParams: { emails, message },
    },
    strings: {
      actionString: 'Share',
      confirmString: 'Are you sure? This campaign quote will be sent via email to the selected recipients.',
      entityName: 'Quote',
    },
  }

  return (
    <Button
      buttonStyle="primaryCreate"
      disabled={!hasSelectedUsers}
      loading={creating}
      // @ts-expect-error TS2345
      onClick={() => confirmAction(sendQuotePayload)}
      size="large"
    >
      {hasSelectedUsers ? 'Send Quote' : 'Add Recipient'}
    </Button>
  )
}

export default ShareQuoteButton
